import { render, staticRenderFns } from "./MyTicket.vue?vue&type=template&id=5a40266c&"
import script from "./MyTicket.vue?vue&type=script&lang=js&"
export * from "./MyTicket.vue?vue&type=script&lang=js&"
import style0 from "./MyTicket.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports